import { MENU_API_NO_CACHE } from '@/lib/menuFallback';

/**
 * Carga conocimiento del asistente fuera del hot path GET /menu/:id (B3).
 * @param {import('@/soluqr/api/client').default} api
 * @param {string} businessId
 * @returns {Promise<object|null>}
 */
export async function fetchPublicAssistantTraining(api, businessId) {
  const id = String(businessId || '').trim();
  if (!id) return null;
  try {
    const { data } = await api.get(
      `/menu/${encodeURIComponent(id)}/assistant-training`,
      MENU_API_NO_CACHE,
    );
    const training = data?.assistant_training;
    return training && typeof training === 'object' ? training : null;
  } catch {
    return null;
  }
}

/**
 * @param {object|null|undefined} menuPayload
 * @param {object|null|undefined} assistantTraining
 */
export function mergeAssistantTrainingIntoMenuPayload(menuPayload, assistantTraining) {
  if (!menuPayload || typeof menuPayload !== 'object') return menuPayload;
  if (!assistantTraining || typeof assistantTraining !== 'object') return menuPayload;
  const business = menuPayload.business && typeof menuPayload.business === 'object'
    ? { ...menuPayload.business, assistant_training: assistantTraining }
    : { assistant_training: assistantTraining };
  return { ...menuPayload, business };
}
